<template>
    <div>
        <div class="leaseSmart">
            <img src="~assets/image/lease/leaseSmart.png" alt />
        </div>
        <!-- 产品方案 -->
        <div class="productPlan clearfix">
            <div class="leftRule">
                <product-solution/>
            </div>

            <div class="image">
                <img src="~assets/image/lease/leaseNav.jpg" alt />
            </div>
        </div>

        <!-- 租赁产品 -->
        <div class="warpper clearfix">
            <!-- 规则 -->
            <div class="rule">
                <!-- 快易托 -->
                <lease-desc />
            </div>
            <!-- 托盘租赁 -->
            <div class="content">
                <product-list />
            </div>
        </div>

    </div>
</template>

<script>

import productList from './product-list';
import leaseDesc from './lease-desc';
import productSolution from './product-solution'

export default {
    components: { productList, leaseDesc,productSolution},
    data() {
        return {
            titleShow: 0,
            tabsList: [
                { title: '普惠托', value: 'prattPlattet' },
                { title: '快易托', value: 'fastPlattet' },
                { title: '随心托', value: 'beSatisfied' },
                { title: '顺风托', value: ' tailwindPlattet' },
            ]
        }
    },

    methods: {

    }

}
</script>

<style lang="less" scoped>
.leaseSmart {
    width: 100%;
    height: 186px;
    margin-top: 20px;
    img {
        width: 100%;
    }
}
.warpper {
    width: 100%;
    .rule {
        float: left;
        width: 218px;
        height: 490px;
        margin-top: 20px;
        border: 1px solid #cacaca;
    }
    .content {
        float: right;
        width: 830px;
        // height: 100vh;
        .tabs {
            width: 462px;
            height: 37px;
            border: 1px solid #cacaca;
            line-height: 37px;
            text-align: center;
            box-sizing: border-box;
            li {
                width: 115px;
                height: 100%;
                float: left;
                font-weight: bold;
                cursor: pointer;
            }
            .tabsActive {
                background: #ff9000;
                color: #fff;
            }
        }
    }
}
.productPlan {
    .leftRule {
        float: left;
        width: 218px;
        height: 436px;
        margin-top: 20px;
        border: 1px solid #cacaca;
    }
    .image {
        margin-top: 20px;
        width: 830px;
        float: right;
    }
}
</style>